module.exports = __webpack_public_path__ + "img/user.d43398fc.svg";